// useService.js
import React, { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import moment from 'moment';
import 'moment/locale/es';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';

import { sendRequest } from "../../hooks/requests/useRequest";
import { getInformationCompany } from '../../services/company/company';

export const useMassPrintingResults = () => {

    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate,sweetDeleteBacterium1,sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal,sweetAcceptGlobal] = useSweetAlert();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [listCompanies, setListCompanies] = useState([]);
    const [results, setResults] = useState([]);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [lotes, setLotes] = useState([]);
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [selectedLote, setSelectedLote] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState({ value: null, label: "Todos" });

    const [selectedExams, setSelectedExams] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const [showDialogLetter, setShowDialogLetter] = useState(false);
    const [letterhead, setLetterhead] = useState(false);


    const [formValues, handleInputChange, reset, handleUpdateValues,handleSelectValues] = useForm({
        id_company: "",
        start_date: "",
        end_date: "",
        letter: false,
    });
    
 
    const { id_company, start_date, end_date, letter } = formValues;


    const handleSearch = (e, search = true) => {
        if (e) e.preventDefault();

        if (search) {
            if (!id_company?.value && !start_date && !end_date) {
                createSweet("info", "info", "Atención", "Debes seleccionar una empresa y un rango de fechas.");
                return;
            } else if (!id_company?.value) {
                createSweet("info", "info", "Atención", "Debes seleccionar una empresa.");
                return;
            } else if (!start_date || !end_date) {
                createSweet("warning", "info", "Atención", "Debes seleccionar un rango de fechas.");
                return;
            }

            let query = "";
            const _from = start_date ? moment(start_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            const _to = end_date ? moment(end_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            const companyId = id_company?.value ?? "";
            const statusId = selectedStatus?.value;

            query += `from=${_from}&to=${_to}`;
            if (companyId !== "") query += `&id_company=${companyId}`;
            if (statusId !== null) query += `&id_status=${statusId}`;

            setIsDownloading(true);
            fetchWorkOrders(query);
        }
    };


    const fetchWorkOrders = async (_filter) => {
        try {
            const data = await handleRequest("GET", `BatchResults/ListWorkOrders?${_filter}`, "ListWorkOrders");
            if (data && Array.isArray(data)) {
                setResults(data);
            } else {
                setResults([]);
                createSweet("info", "info", "No se encontraron registros para los filtros seleccionados.");
            }
        } catch (err) {
            createSweet("error", "error", "Error", "No se pudo obtener la información.");
        } finally {
            setIsDownloading(false);
        }
    };


    const handleGenerateLote = async (selectedExams = []) => {
        try {
            if (!selectedExams || selectedExams.length === 0) {
                createSweet("warning", "warning", "Atención", "Selecciona al menos un registro para generar el lote.");
                return;
            }

            const workOrderIds = selectedExams.map(r => r.id_work_order);

            const companyId = id_company?.value ?? 0;

            const _from = start_date ? moment(start_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            const _to = end_date ? moment(end_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");

            const payload = {
                ids_work_orders: workOrderIds,
                from: _from,
                to: _to,
                id_company: companyId,
                id_agreement: null,
                id_branch: null,
                letterhead: letterhead 
            };

            setIsLoading(true);

            const response = await handleRequest(
                "POST",
                "BatchResults/CreateBatch",
                "Generar Lote",
                payload
            );

            if (response) {
                createSweet("success", "success", "Éxito", "El lote se generó correctamente.");

                if (Array.isArray(lotes)) {
                    setLotes(prev => [...prev, response]);
                } else {
                    setLotes([response]);
                }
                clearAll();
                setActiveTab(1);
            } else {
                createSweet("error", "error", "Error", "No se pudo generar el lote. Intenta nuevamente.");
            }

        } catch (error) {
            createSweet("error",  "error", "Error", "No se pudo generar el lote. Verifica los datos e inténtalo nuevamente.");
        } finally {
            setIsLoading(false);
        }
    };


    const fetchLotes = async () => {
        try {
            const data = await handleRequest("GET", "BatchResults/ListBatchResults", "ListBatchResults");
            if (data && Array.isArray(data)) {
                setLotes(data);
                return data;
            } else {
                setLotes([]);
                return []; 
            }
        } catch (err) {
            // console.error("Error al listar lotes:", err);
            return [];
        }
    };

    // useEffect(() => {
    //     if (activeTab === 1) {
    //         fetchLotes(); 
    //         const interval = setInterval(fetchLotes, 5000);
    //         return () => clearInterval(interval);
    //     }
    // }, [activeTab]);

    useEffect(() => {
        let interval;

        const startInterval = async () => {
            const data = await fetchLotes();

            const hasPending = data.some(lote => lote.ended_process === null);

            if (hasPending) {
                interval = setInterval(async () => {
                    const updatedData = await fetchLotes();

                    const stillPending = updatedData.some(lote => lote.ended_process === null);
                    if (!stillPending) {
                        clearInterval(interval);
                    }
                }, 2500);
            }
        };

        if (activeTab === 1) {
            startInterval();
        }

        return () => clearInterval(interval);
    }, [activeTab]);




    const fetchCompaniesList = async () => {
        const listTmp = await handleRequest(
            "GET",
            `Company/List`,
            "Clientes"
        );

        if (listTmp && listTmp.length > 0) {
            const list = listTmp
                .filter(obj => obj.block_company !== 0)
                .map(obj => ({
                    value: obj.id_company,
                    label: obj.name,
                }));
            setListCompanies(list);
        } else {
            setListCompanies([]);
        }
    };

    useEffect(() => {
        fetchCompaniesList();
    }, []);



    
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {

            return response.data;

        }
        else if (response.code === 409) {
        }
        else if (response.code === 500) {
        }
        else {
        }
        return null;
    }

    // #region Download PDF
    const handleDownloadPDF = async (row) => {
        try {
            if (!row || !row.result_file) {
                createSweet("warning", "warning", "Advertencia", "Archivo no disponible", "No se encontró el PDF para descargar.");
                return;
            }

            setIsButtonDisabled(true);
            setLoadingPdf(true);

            const token = localStorage.getItem("token");
            const response = await fetch(`/api/BatchResults/Download/${row.result_file}`, {
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });


            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = row.result_file;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);

            createSweet("success", "success", "Éxito", "Descarga completada", "El PDF se descargó correctamente.");
        } catch (error) {
            console.error(error);
            createSweet("error", "error", "Error", "Error al descargar el PDF", error.message);
        } finally {
            setIsButtonDisabled(false);
            setLoadingPdf(false);
        }
    };

    //#endregion

    // #region print pdf
    const handlePrintPDF = async (row) => {
        try {
            if (!row || !row.result_file) {
                createSweet("warning","warning","Advertencia", "Archivo no disponible", "No se encontró el PDF para imprimir.");
                return;
            }

            setIsButtonDisabled(true);
            setLoadingPdf(true);

            const token = localStorage.getItem("token");
            const response = await fetch(`/api/BatchResults/Download/${row.result_file}`, {
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + token
                }
            });

            if (!response.ok) throw new Error("No se pudo abrir el PDF.");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = url;
            document.body.appendChild(iframe);

            iframe.onload = function () {
                setTimeout(() => {
                    iframe.contentWindow.print();
                    URL.revokeObjectURL(url);
                }, 500);
            };
        } catch (error) {
            console.error(error);
            createSweet("error", "error", "Error", "No se pudo imprimir el PDF", error.message);
        } finally {
            setIsButtonDisabled(false);
            setLoadingPdf(false);
        }
    };

    // #endregion

    //#region Select Status

    const optionsStatus = [
        { value: null, label: "Todos" },
        { value: 1, label: "Pendiente" },
        { value: 2, label: "Procesado" },
        { value: 3, label: "Actualizado tras impresión" },
    ];

    // #endregion

    // #region Delete Batch
    const handleClearBatch = async (lote) => {
        if (!lote) return;

        const confirm = await sweetAcceptGlobal(
            "¿Seguro que quieres eliminar este lote?",
            "Esta acción eliminará el registro del lote.",
            "warning",
            true
        );

        if (!confirm) return;

        try {
            const response = await handleRequest(
                "DELETE",
                `BatchResults/DeleteBatchResult/${lote.id_batch_result}`,
                "Eliminar Lote"
            );

            if (response) {
                createSweet("success", "success", "Éxito", "El lote se eliminó correctamente.");
                fetchLotes();
            } else {
                createSweet("error", "error", "Error", "No se pudo eliminar el lote.");
            }
        } catch (err) {
            console.error(err);
            createSweet("error", "error", "Error", "Ocurrió un error al eliminar el lote.");
        }
    };

    // #endregion

    // #region Delete all lotes
    const handleClearAllBatches = async () => {
        const confirm = await sweetAcceptGlobal(
            "¿Seguro que quieres eliminar todos los lotes?",
            "Esta acción eliminará todos los registros de lotes y no se podrá deshacer.",
            "warning",
            true
        );

        if (!confirm) return;

        try {
            const response = await handleRequest(
                "DELETE",
                "BatchResults/DeleteAllBatchResults",
                "Eliminar todos los lotes"
            );

            if (response) {
                createSweet("success", "success", "Éxito", "Todos los lotes se eliminaron correctamente.");
                setLotes([]);
            } else {
                createSweet("error", "error", "Error", "No se pudieron eliminar los lotes.");
            }
        } catch (err) {
            console.error(err);
            createSweet("error", "error", "Error", "Ocurrió un error al eliminar los lotes.");
        }
    };



    // #region Excel Error nims pdf

    const downloadExcelErrors = async (lote) => {
        if (!lote || !lote.error_nims || lote.error_nims.length === 0) return;

        const XLSX = await import("xlsx");

        const report = lote.error_nims.map((nim, index) => ({
            "#": index + 1,
            NIM: nim
        }));

        const worksheet = XLSX.utils.json_to_sheet(report);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Errores");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Nims-Errores${lote?.name_company || "lote"}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };


    const clearAll = () => {
        reset(); 
        setResults([]); 
        setSelectedExams([]);
        setSearchTerm("");
        setSelectedStatus({ value: null, label: "Todos" });

        setResults(prev => [...prev]); 
    };


    return {
        start_date,
        end_date,
        handleInputChange,
        isDownloading,
        isButtonDisabled,
        handleSelectValues,
        listCompanies,
        id_company,
        letter,
        handleSearch,
        results,
        handleGenerateLote, handleDownloadPDF, handlePrintPDF, optionsStatus, selectedStatus, setSelectedStatus, activeTab, setActiveTab, lotes, isLoading, visibleDialog, setVisibleDialog,
        setSelectedLote, selectedLote, handleClearBatch,
        downloadExcelErrors, handleClearAllBatches, selectedExams, setSelectedExams, searchTerm, setSearchTerm,
        showDialogLetter, setShowDialogLetter, letterhead, setLetterhead,
        
        
    };

};
